/**
 * WEB-921 — кто красит СТРАНИЦУ на пути воронки.
 *
 * На пути воронки пейволл рендерится встроенным внутрь обёрток квиза
 * (WEB-744 §3 + WEB-871: своих обёрток он не создаёт). Из-за этого тема
 * пейволла доставалась только внутреннему узлу шириной 680, а весь вьюпорт
 * продолжала красить тема КВИЗА: светлый пейволл выглядел узкой полосой на
 * тёмной странице (находка PM 30.07, десктоп).
 *
 * Механизм: страницу владеет тот, кто рендерит `main` (PublicQuiz). Встроенный
 * пейволл не лезет в DOM и не ломает обёртки — он лишь ОБЪЯВЛЯЕТ свой
 * страничный стиль через контекст, а владелец `main` его применяет. При
 * размонтировании объявление снимается и страница возвращает тему квиза.
 */

import { createContext, useContext, useEffect } from 'react';
import type { CSSProperties } from 'react';

export type FunnelPageStyleSetter = (style: CSSProperties | null) => void;

/**
 * null = страницу никто не «одалживал» (standalone-режимы: пейволл по своему
 * домену, квиз без воронки). Тогда объявление просто игнорируется.
 */
export const FunnelPageStyleContext = createContext<FunnelPageStyleSetter | null>(
  null,
);

/**
 * Объявить страничный стиль на время жизни компонента. Снимается при
 * размонтировании — иначе фон пейволла «залипал» бы после возврата к квизу.
 */
export function useDeclareFunnelPageStyle(style: CSSProperties | null): void {
  const setPageStyle = useContext(FunnelPageStyleContext);
  // Стиль пересобирается каждый рендер (объект-литерал), поэтому в зависимости
  // уходит его СОДЕРЖИМОЕ, а не ссылка — иначе эффект бил бы по кругу.
  const key = style ? JSON.stringify(style) : '';

  useEffect(() => {
    if (!setPageStyle) return;
    setPageStyle(key ? (JSON.parse(key) as CSSProperties) : null);
    return () => setPageStyle(null);
  }, [setPageStyle, key]);
}
